import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { plural } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';

export const Discounts = ({ userGroupId }: { userGroupId: number }) => {
  const { currentBrand } = useCurrentBrand();

  const {
    data: coupons,
    isPending: isCouponsPending,
    error: couponsError
  } = noddiAsync.useGet({
    type: URLKeys.getUserGroupCoupons,
    input: { userGroupId, brandDomain: currentBrand }
  });

  if (isCouponsPending) {
    return <NoddiLoadingScreenWithTrans />;
  }
  if (couponsError) {
    return <ApiErrorPageWithTrans error={couponsError} />;
  }

  const discountsMessage = plural(coupons.results.length, {
    one: 'You have # discount on your account!',
    other: 'You have # discounts on your account!'
  });

  return (
    <div className='flex flex-col gap-2 md:gap-4'>
      <h2 className='text-xl font-bold text-primary md:text-3xl'>
        <Trans>Discounts</Trans>
      </h2>
      <NoddiBasicCard to={customerRoutes.discounts.getPath()} className='flex flex-col gap-5 text-balance'>
        <p className='font-semibold md:text-lg'>
          <Trans>Hurray!</Trans>
        </p>
        <p>{discountsMessage}</p>
        <div className='flex justify-end'>
          <NoddiDummyButton variant='link' endIcon='ArrowRight' className='-mr-4 -mb-2'>
            <Trans>See details</Trans>
          </NoddiDummyButton>
        </div>
      </NoddiBasicCard>
    </div>
  );
};
